module.exports = __webpack_public_path__ + "img/asset_UST.a6975e3c.svg";